// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "BackToTopBtn-module--bx--text-truncate--end--GOa+9";
export var bxTextTruncateFront = "BackToTopBtn-module--bx--text-truncate--front--jVH4e";
export var button = "BackToTopBtn-module--button--Etd6D";